<template>
  <div>
    <b-modal
      :title="getTitleModal"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('close')"
      no-close-on-backdrop
      no-close-on-esc
      v-model="show"
    >
      <b-alert v-if="existePeriodo" variant="warning" show class="p-1 mb-2">
        Ya existe una gratificación para el periodo
        <strong>{{ form.anio }} - {{ form.periodo }}</strong
        >.
      </b-alert>

      <ValidationObserver ref="ref-generar-gratificacion">
        <b-row>
          <b-col lg="6" md="6" sm="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="anio"
            >
              <b-form-group :state="errors[0] ? false : null">
                <label class="form-label">
                  Año <span class="text-danger">(*)</span>
                </label>
                <v-select
                  v-model="form.anio"
                  :options="anios"
                  label="name"
                  :reduce="(anio) => anio.id"
                  placeholder="Seleccione ..."
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col lg="6" md="6" sm="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="periodo"
            >
              <b-form-group :state="errors[0] ? false : null">
                <label class="form-label">
                  Periodo <span class="text-danger">(*)</span>
                </label>
                <v-select
                  v-model="form.periodo"
                  :options="periodos"
                  label="name"
                  :reduce="(periodo) => periodo.id"
                  placeholder="Seleccione ..."
                />
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </ValidationObserver>

      <div class="d-flex justify-content-end gap-x-3">
        <b-button
          variant="outline-primary"
          @click="generarGratificacion"
          :disabled="existePeriodo"
        >
          GENERAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import GratificacionesService from "@/views/rrhh/views/payroll/components/gratificaciones/service/gratificaciones.service.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      periodos: [
        { id: "JULIO", name: "Julio" },
        { id: "DICIEMBRE", name: "Diciembre" },
      ],
      show: true,
      form: {
        periodo: null,
        anio: null,
      },
      periodosExistentes: [],
    };
  },
  mounted() {
    this.getPeriodos();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      return "GENERAR GRATIFICACIÓN";
    },
    anios() {
      const year = new Date().getFullYear();
      const startYear = 2020;
      const years = [];
      for (let y = startYear; y <= year; y++) {
        years.push({ id: y, name: y });
      }
      return years;
    },
    existePeriodo() {
      if (!this.form.anio || !this.form.periodo) return false;
      return this.periodosExistentes.some(
        (p) =>
          Number(p.anio) === Number(this.form.anio) &&
          p.periodo.toUpperCase() === this.form.periodo.toUpperCase()
      );
    },
  },
  methods: {
    async generarGratificacion() {
      try {
        const result = await this.$refs["ref-generar-gratificacion"].validate();
        if (result) {
          const confirm = await this.showConfirmSwal(
            `¿Está seguro de generar la gratificación para el periodo ${this.form.anio} - ${this.form.periodo}?`,
            "Esta acción no se puede deshacer."
          );
          if (confirm.isConfirmed) {
            this.addPreloader();

            const { data } = await GratificacionesService.generar(this.form);

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: data.message,
                icon: "CheckCircleIcon",
                variant: "success",
                text: data.message,
              },
            });

            this.$emit("generated");
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XCircleIcon",
            variant: "danger",
            text: error?.response?.data || error.message || error,
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    async getPeriodos() {
      try {
        const { data } = await GratificacionesService.getPeriodos();
        this.periodosExistentes = data || [];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
